import { toast } from "react-toastify";
import { CategoryAPI } from "../constants/apiRoutes";
import { categoryActions } from "../reducers/category";
import apiService from "../utils/configAxios";
import { handleError } from "../utils/handleError";

export const createNewCategory = (data, navigate) => {
  return async (dispatch) => {
    dispatch(categoryActions.actionStart());
    try {
      await apiService.post(CategoryAPI.create(), data);
      dispatch(categoryActions.actionSuccess("create"));
      
    } catch (err) {
      dispatch(categoryActions.clearError());
      handleError(err);
    }
  };
};

export const updateCategory = (data, navigate, id) => {
  return (dispatch) => {
    dispatch(categoryActions.actionStart());
    return apiService
      .put(CategoryAPI.update(id), data)
      .then((response) => {
        dispatch(categoryActions.actionSuccess("update"));
        
        // toast.success("Uspešno ste izmenili kategoriju", {
        //   theme: "colored",
        // });
        // navigate("/category-list");
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const deleteCategory = (id) => {
  return (dispatch) => {
    return apiService
      .delete(CategoryAPI.delete(id))
      .then((response) => {
        toast.success("Uspešno ste obrisali kategoriju", {
          theme: "colored",
        });

        dispatch(fetchCategoryList());
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchCategoryList = () => {
  return (dispatch) => {
    return apiService
      .get(CategoryAPI.list())
      .then((response) => {
        dispatch(categoryActions.fetchCategoryList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchCategoryFormList = () => {
  return (dispatch) => {
    dispatch(categoryActions.actionStart());
    return apiService
      .get(CategoryAPI.form())
      .then((response) => {
        dispatch(categoryActions.fetchCategoryFormList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchCategoryById = (id = 0) => {
  return (dispatch) => {
    return apiService
      .get(CategoryAPI.getById(id))
      .then((response) => {
        dispatch(categoryActions.fetchCategoryDetail(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};
